import React, { useContext, useEffect, useState } from "react";
import {
  Col,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { Btn, H3 } from "../../../AbstractElements";
import { Cancel, Save, Selectdefault } from "../../../Shared/Constants";
import { useForm } from "react-hook-form";
import InputError from "../../../Shared/Components/Form/InputError";

import { togleLoading } from "../../../Shared/Utils/alertLoading";

import ProvinceContext from "../Context/Index";

export default function ProvinceForm() {
  //context
  const {
    createItem,
    apiErrors,
    modalTogle,
    showModal,
    item,
    updateItem,
    saving,
  } = useContext(ProvinceContext);
  //form
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isDirty },
  } = useForm();

  const onSubmit = (data) => {
    if (item && item?.id) {
      updateItem(data, item?.id);
    } else {
      createItem(data);
    }
  };

  //set default values to form
  useEffect(() => {
    console.log("name", item);

    reset({
      name: item?.name,
    });
  }, [item]);

  //alert
  const [alertOpen, setAlertOpen] = useState(
    apiErrors && apiErrors.length > 0 ? true : false
  );

  const ToggleAlert = () => setAlertOpen(!alertOpen);

  //usefect
  useEffect(() => {
    setAlertOpen(apiErrors && apiErrors.length > 0 ? true : false);
  }, [apiErrors]);

  useEffect(() => {
    togleLoading(saving);
  }, [saving]);

  return (
    <Form onSubmit={handleSubmit(onSubmit)} id="citiesForm">
      <Modal
        isOpen={showModal}
        toggle={modalTogle}
        className="rounded-1"
        size="md"
      >
        <ModalHeader toggle={modalTogle}>
          <div>
            <H3
              attrH3={{
                className: "modal-title",
                id: "exampleModalLabel1",
              }}
            >
              {item?.id ? "Modificar provincia" : "Agregar provincia"}
            </H3>
          </div>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm="12">
              <FormGroup className="mb-3 col-md-12">
                <Label htmlFor="name" className="form-label">
                  Nombre
                </Label>
                <input
                  className="form-control"
                  type="text"
                  required=""
                  placeholder="Ingresa el nombre de la provincia"
                  autoComplete="off"
                  {...register("name", {
                    required: "El nombre es obligatorio",
                  })}
                />
                <InputError errors={errors} name="name" />
              </FormGroup>
            </Col>
          </Row>
          <Btn
            attrBtn={{
              color: "secondary",
              className: "ms-1",
              onClick: modalTogle,
            }}
          >
            {Cancel}
          </Btn>
          <Btn
            attrBtn={{
              type: "submit",
              form: "citiesForm",
              className: "ms-1",
              color: `${isDirty ? "primary" : "secondary"}`,
              disabled: !isDirty,
            }}
          >
            {Save}
          </Btn>
        </ModalBody>
      </Modal>
    </Form>
  );
}
